import React from 'react';
import { UserCheck, Sparkles, TrendingUp, ArrowRight, ShieldCheck } from 'lucide-react';
import './HowItWorks.css';

const steps = [
  {
    step: '01',
    icon: <UserCheck size={24} />,
    title: 'Create Your Account in 30 Seconds',
    description:
      "Sign in with Google, add your child's username, pick their grade, and set a simple password so they can easily log in on their own.",
    tag: 'Instant Setup',
  },
  {
    step: '02',
    icon: <Sparkles size={24} />,
    title: '10 Minutes of Daily Curriculum Play',
    description:
      'Your child logs in on any tablet, laptop, or phone using their own username and password to complete daily bite-sized quizzes.',
    tag: 'Guilt-Free Screen Time',
  },
  {
    step: '03',
    icon: <TrendingUp size={24} />,
    title: 'Track Real Progress Without Hovering',
    description:
      'Check your parent dashboard anytime. Spot learning gaps early, monitor accuracy trends, and celebrate test readiness without the homework arguments.',
    tag: 'Mastery Reports',
  },
];

export default function HowItWorks({ onGetStarted }) {
  return (
    <section className="how-it-works-dark">
      <div className="how-it-works-container">
        
        {/* Centered Vertical Header */}
        <div className="how-it-works-header">
          <span className="how-it-works-badge">Simple 3-Step Setup</span>
          <h2 className="how-it-works-title">
            Built for Busy Parents. <br />
            <span>Loved by Curious Kids.</span>
          </h2>
          <p className="how-it-works-subtitle">
            No complicated downloads. Set up your parent dashboard and your child's student login in under a minute.
          </p>
        </div>

        {/* 3 Steps Cards */}
        <div className="how-it-works-grid">
          {steps.map((item) => (
            <div key={item.step} className="dark-step-card">
              <div className="dark-card-top">
                <span className="dark-step-num">{item.step}</span>
                <div className="dark-icon-badge">{item.icon}</div>
              </div>

              <div className="dark-card-content">
                <span className="dark-pill">{item.tag}</span>
                <h3 className="dark-card-title">{item.title}</h3>
                <p className="dark-card-desc">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div className="how-it-works-footer">
          <div className="dark-trust-badge">
            <ShieldCheck size={18} className="shield-icon" />
            <span>Child-safe, 100% ad-free learning environment</span>
          </div>
          
          <button 
            type="button" 
            className="btn-gold-cta"
            onClick={onGetStarted}
          >
            Start Your Child's Journey Free
            <ArrowRight size={18} />
          </button>
        </div>

      </div>
    </section>
  );
}